import React , { useEffect } from 'react';
import { useForm  , Controller } from "react-hook-form";

import Button from '../../../../../partials/Button/Button';
import CustomSelect from '../../../../../partials/Form/Select/CustomSelect';

import styles from './CouncilModale.module.scss';

export default function CrosModale({ doctors , doctorsOptions , submitCros }) {

  const { handleSubmit, register, errors , setValue , control } = useForm();

  useEffect(() => {
    register("doctor");
  }, [register]);

  function addDoctor(values) {
    submitCros([...doctors.map(d => ({ doctor: d.doctor._id })) , values ])
  }

  return (
    <div className={`modale-content ${styles.container}`}>
      <h2>Ajouter un médecin</h2>
        <form onSubmit={handleSubmit(addDoctor)}>
          <Controller
            name="doctor"
            rules={{ required: "le médecin est requis" }}
            control={control}
            render={(props) =>
              <CustomSelect
                label={"Nom du médecin"}
                defaultValue={null}
                handleChange={(opt) => setValue('doctor' , opt.value)}
                options={doctorsOptions}
                withErrors={true}
                error={errors.doctor && errors.doctor.message}
                />
            }
            defaultValue={null}
          />

          <div className="modale-actions center">
            <Button
              type={"submit"}
              primary
              >
              Valider
            </Button>
          </div>
        </form>
    </div>
  )
}
